import { useToast } from "@/hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { CheckCircle2, XCircle, AlertTriangle, Info } from "lucide-react";
import { cn } from "@/lib/utils";

const toastIcons = {
  default: null,
  destructive: XCircle,
  success: CheckCircle2,
  warning: AlertTriangle,
  info: Info,
};

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const Icon = variant ? toastIcons[variant] : null;

        return (
          <Toast key={id} variant={variant} {...props}>
            {Icon && (
              <Icon
                className={cn(
                  "h-5 w-5 shrink-0",
                  variant === "destructive" && "text-red-600 dark:text-red-400",
                  variant === "success" && "text-green-600 dark:text-green-400",
                  variant === "warning" && "text-yellow-600 dark:text-yellow-400",
                  variant === "info" && "text-blue-600 dark:text-blue-400"
                )}
              />
            )}
            <div className="grid gap-1 flex-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
